module.exports = __webpack_public_path__ + "img/hotel-dining.9b9a3f89.jpeg";